import { PersonAPI } from '@frontend/api-person';
import { createStoreWithSubscribe, createShallowStore } from '@frontend/store';

export interface PhotoStore {
  photoRecord: Record<string, string>;
  setPhotoRecord: (id: string, imgUrl: string) => void;
  handleGetPicture: (id: string) => Promise<string | undefined>;
  pendingRequests: Record<string, Promise<string> | undefined>;
}

export const usePhotoStore = createStoreWithSubscribe<PhotoStore>(
  (set, get) => ({
    photoRecord: {},
    pendingRequests: {},
    setPhotoRecord: (personId: string, imgUrl: string) => {
      set((state) => {
        state.photoRecord[personId] = imgUrl;
      });
    },
    handleGetPicture: async (id: string) => {
      const photo = get().photoRecord[id];
      if (photo !== undefined) {
        return photo;
      }

      // Only proceed if there is no pending request for this id
      if (get().pendingRequests[id]) return;

      const promise = PersonAPI.getPersonImage(id)
        .then((photoData) => {
          set(
            (state) => {
              state.photoRecord[id] = photoData;
              delete state.pendingRequests[id];
            },
            false,
            'SET_SHOW_CONTACT_PANEL'
          );
          return photoData;
        })
        .catch(() => {
          set(
            (state) => {
              state.photoRecord[id] = '';
              delete state.pendingRequests[id];
            },
            false,
            'SET_SHOW_CONTACT_PANEL'
          );
          return '';
        });

      set((state) => {
        state.pendingRequests[id] = promise;
      });

      return promise;
    },
  }),
  { name: 'PhotoStore', trace: true }
);

export const usePhotoShallowStore = createShallowStore(usePhotoStore);
